        <div style="width: 100%; height: 60px;">
            <div style="float:right; width: 180px; cursor: pointer;" (click)="onEmail()">
                <img src="../../assets/email.png" alt="Share with email" style="width: 48px; height: auto; vertical-align: middle;">
                <span style="vertical-align: middle;font-weight: bold;margin-left:10px; font-size: 22px;">Email</span>
            </div>
        </div>
      
        <table>
            <tr>
                <td>
                    OWNER(S) NAME:
                </td>
                <td colspan="3">
                    <ol>
                        <li *ngFor="let nm of ownersname">{{nm}}</li>
                    </ol>
                </td>
            </tr>
            <tr>
                <td>PROPERTY TYPE:</td>
                <td  colspan="3"> {{propertytypename}}</td>
            </tr>
            <tr>
                <td>
                    PROPERTY DESCRIPTION:
                </td>
                <td  colspan="3">
                    {{propertydescription}}
                </td>
            </tr>
            <tr>
                <td>
                    PROPERTY ADDRESS:
                </td>
                <td  colspan="3">
                    <ul>
                        <li *ngFor="let adline of propertyaddress">{{adline}}</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>LAST SALES DEED:</td>
                <td style="width: 25%;">{{salesdeeddate *1000 | date:'dd MMM,yyyy'}}</td>
                <td>SURVEY NO:</td>
                <td>{{surveynumber}}</td>
            </tr>
            <tr>
                <td>PROPERTY SIZE (ACTUAL):</td>
                <td>{{area}}</td>
                <td>PROPERTY SIZE (SQ.MTR):</td>
                <td>{{propertyarea}}</td>
            </tr>
            <tr>
                <td>PROPERTY VALUE:</td>
                <td>{{value}}</td>
                <td>PLAN APPROVED:</td>
                <td>{{planapprovaldate *1000 | date:'dd MMM,yyyy'}}</td>
            </tr>
            <tr>
                <td>
                    MORTGAGE DETAILS:
                </td>
                <td  colspan="3">
                    <ul>
                        <li>Loan Account Number: {{financials.loanaccountnumber}}</li>
                        <li>Loan Year: {{financials.loanyear}}</li>
                        <li> Loan Tenure: {{financials.loantenure}}</li>
                        <li>
                        Bank/Lender Name: {{financials.lendername}}
                    </li>
                    <li>
                        Loan Amount: {{financials.loanamount}}
                    </li>
                    <li>
                        <table class="innertable">
                            <tr>
                                <td >
        
                        Name of borrowers / Co-borrowers: 
                    </td>
                    <td>
                        <ul style="margin-left: 10px;">
                            <li *ngFor="let b of financials.borrowers">{{b.borrowername}}</li>
                        </ul>
                    </td>
                    </tr>
                    </table>
                    </li>
                    <li>
                        Mortgage Deed Number: {{financials.mortgagedeednumber}}
                    </li>
                    <li>
                        Lease Agreement Number: {{financials.leaseagreementnumber}}
                    </li>

                    </ul>
                </td>
            </tr>
        </table>
                        
